import { render, staticRenderFns } from "./CommentsSummary.vue?vue&type=template&id=21751174&scoped=true&"
import script from "./CommentsSummary.vue?vue&type=script&lang=js&"
export * from "./CommentsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21751174",
  null
  
)

component.options.__file = "CommentsSummary.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VContainer,
  VDivider,
  VFlex,
  VLayout,
  VSpacer,
})
